import { Document, Page, Text, View } from "@react-pdf/renderer";
import { styles } from "../../../../components/Pdf/pdfGeneral/EstiloPdf";
import HeaderReport from "../../../../components/Pdf/Header";

const typeHeaderCell = (tam, index) => {
  if (index === 0) {
    return tam === 100
      ? styles.cellHeader100Borders
      : tam === 75
      ? styles.cellHeader75Borders
      : tam === 50
      ? styles.cellHeader50Borders
      : tam === 25
      ? styles.cellHeader25Borders
      : tam === 11
      ? styles.cellHeader11Borders
      : "";
  } else {
    return tam === 100
      ? styles.cellContent100LBR
      : tam === 88.7
      ? styles.cellContent88_7BordersLBR
      : tam === 75
      ? styles.cellHeader75BordersRTB
      : tam === 50
      ? styles.cellHeader50BordersRTB
      : tam === 25
      ? styles.cellHeader25BordersRTB
      : tam === 11
      ? styles.cellHeader11BordersRTB
      : "";
  }
};

const insertHeaders = (model) => {
  return (
    <>
      <View style={styles.tableRow} fixed>
          <View style={[typeHeaderCell(25, 0), { fontSize: 5 }]}>
            <Text>NUMERO EMPLEADO</Text>
          </View>
          <View style={[typeHeaderCell(25, 1), { fontSize: 5 }]}>
            <Text>NOMBRE</Text>
          </View>
          <View style={[typeHeaderCell(25, 1), { fontSize: 5 }]}>
            <Text>ESTATUS DE EMPLEADO</Text>
          </View>
          <View style={[typeHeaderCell(25, 1), { fontSize: 5 }]}>
            <Text>AREA</Text>
          </View>
          <View style={[typeHeaderCell(25, 1), { fontSize: 5 }]}>
            <Text>VIGENTE</Text>
          </View>
          <View style={[typeHeaderCell(25, 1), { fontSize: 5 }]}>
            <Text>FECHA DE INICIO</Text>
          </View>
          <View style={[typeHeaderCell(25, 1), { fontSize: 5 }]}>
            <Text>FECHA DE TERMINO</Text>
          </View>
      </View>
    </>
  );
};

const insertContent = (data) => {
  return (
    <>
      {data.map((obj, index) => (
        <View style={styles.tableRow} wrap={false}>
          <View style={[styles.cellContent25BordersLBR, { fontSize: 5, paddingLeft:5, paddingRight:5 }]}>
            <Text>{obj.staffNumber}</Text>
          </View>
          <View style={[styles.cellContent25BordersRB, { fontSize: 5, paddingLeft:5, paddingRight:5 }]}>
            <Text>{obj.nombreCompleto}</Text>
          </View>
          <View style={[styles.cellContent25BordersRB, { fontSize: 5, paddingLeft:5, paddingRight:5 }]}>
            <Text>{obj.nameStat}</Text>
          </View>
          <View style={[styles.cellContent25BordersRB, { fontSize: 5, paddingLeft:5, paddingRight:5 }]}>
            <Text>{obj.nameArea}</Text>
          </View>
          <View style={[styles.cellContent25BordersRB, { fontSize: 5, paddingLeft:5, paddingRight:5 }]}>
            <Text>{obj.vigente}</Text>
          </View>
          <View style={[styles.cellContent25BordersRB, { fontSize: 5, paddingLeft:5, paddingRight:5 }]}>
            <Text>{obj.startDate}</Text>
          </View>
          <View style={[styles.cellContent25BordersRB, { fontSize: 5, paddingLeft:5, paddingRight:5 }]}>
            <Text>{obj.endDate}</Text>
          </View>
        </View>
      ))}
    </>
  );
};

const insertTitles = (model, title) => {
  return (
    <>
      <HeaderReport/>
      <View>
        <Text style={styles.title}>{title}</Text>
      </View>
    </>
  );
};

const insertFooter = (fileNo) => {
  return (
    <>
      <View fixed style={styles.spaceFooter}></View>
      <View fixed style={styles.footer}>
        <Text style={styles.textFooter}>{fileNo}</Text>
        <Text
          style={styles.textFooter}
          render={({ pageNumber, totalPages }) =>
            `PAGINA : ${pageNumber} / ${totalPages}`
          }
        />
      </View>
    </>
  );
};

const insertTablePuesto = (data) => {
  return (
    <View style={{marginBottom:20}}>
      <View style={[styles.tableRow]} fixed>
        <View style={[typeHeaderCell(25, 0), { fontSize: 5 }]}>
          <Text>NUMERO DE PLAZA</Text>
        </View>
        <View style={[typeHeaderCell(25, 1), { fontSize: 5 }]}>
          <Text>PUESTO LABORAL</Text>
        </View>
        <View style={[typeHeaderCell(25, 1), { fontSize: 5 }]}>
          <Text>NIVEL-RANGO</Text>
        </View>
        <View style={[typeHeaderCell(25, 1), { fontSize: 5 }]}>
          <Text>TIPO DE PLAZA</Text>
        </View>
        <View style={[typeHeaderCell(25, 1), { fontSize: 5 }]}>
          <Text>STATUS DE PLAZA</Text>
        </View>
        <View style={[typeHeaderCell(25, 1), { fontSize: 5 }]}>
          <Text>VACANTE</Text>
        </View>
      </View>

      
      <View style={styles.tableRow} fixed>
        <View style={[styles.cellContent25BordersLBR, { fontSize: 5 }]}>
          <Text>{data[0].idJobPosition}</Text>
        </View>
        <View style={[styles.cellContent25BordersRB, { fontSize: 5 }]}>
          <Text>{data[0].nameJob}</Text>
        </View>
        <View style={[styles.cellContent25BordersRB, { fontSize: 5 }]}>
          <Text>{data[0].LevelRango}</Text>
        </View>
        <View style={[styles.cellContent25BordersRB, { fontSize: 5 }]}>
          <Text>{data[0].namePositionType}</Text>
        </View>
        <View style={[styles.cellContent25BordersRB, { fontSize: 5 }]}>
        <Text>{data[0].nameStatJobposition }</Text>
        </View>
        <View style={[styles.cellContent25BordersRB, { fontSize: 5 }]}>
          <Text>{data[0].vacante}</Text>
        </View>
      </View>
    </View>
  );
};

const generateReport = (data, model, title, fileNo) => {
  return (
    <Document>
      <Page style={styles.body}>
        <View style={styles.tableCell}>
          {insertTitles(model, title)}
          {insertTablePuesto(data)}
          {insertHeaders(model)}
          {insertContent(data)}
          <View style={styles.tableRow}></View>
        </View>
        {insertFooter(fileNo)}
      </Page>
    </Document>
  );
};
export function generatePdfHistoricoPlazas(
  data,
  model,
  title,
  fileNo,
  acumNeto,
  acumAmount,
  final
) {
  const report = generateReport(
    data,
    model,
    title,
    fileNo,
    acumNeto,
    acumAmount,
    final
  );
  return {
    report: report,
  };
}
